import Cookies from 'js-cookie';

const $ = jQuery;
const $window = $(window);

const initIntroVideo = () => {
  const els = once('intro-video', '.om-video-overlay');
  els.forEach((el) => {
    const $this = $(el);
    const $playBtn = $this.find('.om-intro-play');
    const $closeBtn = $this.find('.om-overlay-close');
    const $iframeObj = $('#om-intro-embed');
    const $embedSrc = $iframeObj.attr('src');

    const hasPlayed = Cookies.get('om-video-intro');
    const langCode = drupalSettings.language;
    let displayStatus = { [langCode]: 'true' };

    function overlayDisplay() {
      $this.css('display', 'flex');

      $playBtn.click(function () {
        const url = new URL($embedSrc);
        url.searchParams.set('autoplay', '1');
        $iframeObj.attr('src', url.toString());
        $iframeObj.show();
        $playBtn.hide();
        $('.om-intro-preview').hide();
      });

      $closeBtn.click(() => $this.remove());

      Cookies.set('om-video-intro', JSON.stringify(displayStatus), {
        expires: new Date(new Date().getTime() + 15 * 60 * 1000),
      });
    }

    if (typeof hasPlayed === 'string' && hasPlayed !== '{}') {
      const hasPlayedObj = JSON.parse(hasPlayed);
      if (!hasPlayedObj[langCode]) {
        displayStatus = { ...hasPlayedObj, [langCode]: 'true' };
        overlayDisplay();
      }
      return;
    }
    overlayDisplay();
  });
};

$window.on('load', function () {
  initIntroVideo();
});
